import React from "react";

const FactionOnFire = ({ factions, TopArmyIcon }) => {
  return (
    <div className="rounded-lg bg-gray-800 p-6 shadow-lg self-start">
      <h2 className="mb-4 text-2xl font-semibold text-center">Faction On Fire</h2>
      {TopArmyIcon && <img src={TopArmyIcon} alt="Top Army" className="w-40 h-40 mx-auto mb-4" />}
      <table className="w-full table-auto">
        <thead>
          <tr className="bg-gray-700">
            <th className="px-2 py-1 text-left">Pos.</th>
            <th className="px-2 py-1 text-left">Army</th>
            <th className="px-2 py-1 text-center">GP</th>
            <th className="px-2 py-1 text-center">TP</th>
          </tr>
        </thead>
        <tbody>
          {factions.flatMap(f => f.armies).map((army, index) => (
            <tr key={index} className="hover:bg-gray-600">
              <td className="px-2 py-1">{index + 1}</td>
              <td className="px-2 py-1">{army.army_name}</td>
              <td className="px-2 py-1 text-center">{army.won + army.lost + army.drawn}</td>
              <td className="px-2 py-1 text-center">{army.points}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FactionOnFire;
